import React from 'react';
import styles from './AcceptChangeSelect.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { changeBetSlipOddDecision } from '../../../store/actions/betSlip';
import { acceptOddChangeEnum } from '../../../constants/enums';
import useComponentVisible from '../../../hooks/useComponentVisible';
import { getTranslation } from '../../../utils/translation';

const decisionsLabels = {
    [acceptOddChangeEnum.YES]: {
        id: 'betSlip.select.option.acceptAny',
    },
    [acceptOddChangeEnum.NO]: {
        id: 'betSlip.select.option.dontAccept',
    },
    [acceptOddChangeEnum.HIGHER]: {
        id: 'betSlip.select.option.acceptIncrease',
    },
};

const AcceptChangeSelect = () => {
    const dispatch = useDispatch();
    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

    const selectedDecision = useSelector(state => state.betSlip.selectedOddChangeDecision);

    const onDecisionChange = decisionId => {
        setIsComponentVisible(false);
        dispatch(changeBetSlipOddDecision(decisionId));
    };

    return (
        <div className={styles.acceptChange} ref={ref}>
            <div className={styles.selectedItem} onClick={() => setIsComponentVisible(true)}>
                <span className='icon-accept' />
                <span>{getTranslation(decisionsLabels[selectedDecision].id)}</span>
                <span className='icon-arrow-down' />
            </div>

            {isComponentVisible && (
                <ul className={styles.selectItems}>
                    {Object.values(acceptOddChangeEnum).map(decisionId => {
                        const isSelected = selectedDecision === decisionId;
                        return (
                            <li
                                className={`${styles.selectItem} ${
                                    isSelected ? styles.selected : ''
                                }`}
                                key={decisionId}
                                onClick={() => onDecisionChange(decisionId)}
                            >
                                <span
                                    className={`${styles.selectIcon} ${
                                        isSelected ? styles.selected : ''
                                    }`}
                                />
                                <span>{getTranslation(decisionsLabels[decisionId].id)}</span>
                            </li>
                        );
                    })}
                </ul>
            )}
        </div>
    );
};

export default AcceptChangeSelect;
